if ($('#map').length) {
    // URL k CSV souboru
    var csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSv6GxyjuyUS8aPucP0GcC0ar0x8zF1Uy_0liLhGgEKYafkUcLCENSxqa_N0cF196N_6ESo-Uu7xKLb/pub?gid=1302963055&single=true&output=csv';

    // Vytvoření mapy
    var map = L.map('map').setView([49.3, 17.5], 8);

    // Přidej OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    var customIcon = L.icon({
        iconUrl: '/user/documents/upload/sablona-nemazat/vomaPoint.svg', // Změň na URL své vlastní ikony
        iconSize: [25, 41], // Velikost ikony
        iconAnchor: [12, 41], // Bod, který bude umístěn na pozici markeru
        popupAnchor: [1, -34] // Bod, kde se bude zobrazovat popup
    });
    // Načtení CSV dat pomocí PapaParse
    Papa.parse(csvUrl, {
        download: true,
        header: true,
        delimiter: ",",
        complete: function(results) {
            var data = results.data;

            // Vytvoř marker pro každý řádek v CSV
            data.forEach(function(item) {
                var lat = parseFloat(item.latitude);
                var lon = parseFloat(item.longitude);
               // console.log(item)
                if (!isNaN(lat) && !isNaN(lon)) {
                    // Vytvoř marker na mapě
                    var marker = L.marker([lat, lon], { icon: customIcon }).addTo(map);
                    var popupContent = `<b>${item["název dodacího místa"]}</b><br>${item.ulice} ${item["č.p."]}, ${item.obec}, ${item.PSC}`;
                    marker.bindPopup(popupContent);

                    // Zobrazení popup při kliknutí na marker
                    marker.on('click', function() {
                        marker.openPopup();
                    });
                }
            });
        }
    });
}